export const NOTE_ENTITY_TYPE = {
  ACCOUNT: "account",
  CONTACT: "contact",
  OPPORTUNITY: "opportunity",
  LEAD: "lead",
  TASK: "task",
  EMAIL: "email",
  CALENDAR: "calendar",
} as const;

export const TASK_ENTITY_TYPE = {
  ACCOUNT: "account",
  CONTACT: "contact",
  OPPORTUNITY: "opportunity",
  LEAD: "lead",
  TASK: "task",
  EMAIL: "email",
  CALENDAR: "calendar",
} as const;
